import { useCallback, useRef } from 'react';

/**
 * VideoRenderer swaps its "Play video" button for the player controls when
 * playback starts, and back when it ends. If the removed control had focus,
 * focus falls to the page and the dialog stops hearing Escape and Tab. Put
 * `playerRef` on a `tabIndex={-1}` wrapper around the player and pass
 * `keepFocus` to `onPlaybackStarted` and `onPlaybackCompleted`; focus then
 * moves to the wrapper. Two frames: the swap renders after the callback.
 */
export function useKeepFocusOnPlayer() {
  const playerRef = useRef<HTMLDivElement>(null);
  const keepFocus = useCallback(() => {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const active = document.activeElement;
      if (!active || active === document.body || active === document.documentElement) playerRef.current?.focus();
    }));
  }, []);
  return { playerRef, keepFocus };
}
